module.exports = __webpack_public_path__ + "static/media/select-search-icon.d163ef79.svg";